/* BioIndex global, web-and-Android in-app navigation badge. */
import React from "react";
import { useNotificationBadges } from "../context/NotificationBadgeContext";

export default function CommunityNavBadge() {
  const { total } = useNotificationBadges();
  if (!total) return null;
  return (
    <span
      aria-label={`${total} new Community updates`}
      title={`${total} new Community updates`}
      className={`pointer-events-none absolute -right-1 -top-1 z-10 flex h-6 items-center justify-center rounded-full border-2 border-white bg-[#C5537F] text-[10px] font-bold leading-none text-white shadow-[0_3px_10px_rgba(197,83,127,0.3)] ${total > 99 ? "min-w-6 px-1.5" : "w-6"}`}
    >
      {total > 99 ? "99+" : total}
    </span>
  );
}
